import { ActionTypes } from '@lib/domain/order';

export const TWITCH_REGEX_USERNAME =
    /^(https:\/\/(?:www.|m.)?twitch.tv\/)?([a-zA-Z0-9_]{3,})$/;

export const TWITCH_SLIDE_RANGES = {
    view: {
        min: [0, 100],
        '3%': [100, 50],
        '54%': [1000, 100],
        '83%': [2000, 500],
        max: [5000],
    },
    follower: {
        min: [0, 100],
        '4%': [100, 100],
        '45%': [1000, 250],
        '81%': [3000, 500],
        max: [5000],
    },
    stream: {
        min: [0, 50],
        max: [500],
        // max: [1000],
    },
    duration: {
        min: [1, 2],
        '20%': [2, 2],
        '50%': [3, 3],
        max: [6],
    },
};

export const INITIAL_STREAM_PRICES: Record<string, number> = {
    '0.5': 0.058,
    '1': 0.099,
    '2': 0.198,
    '3': 0.298,
    '6': 0.498,
};
export const ACTION_TYPE_TWITCH: Record<number, ActionTypes> = {
    0.5: ActionTypes.live_stream_30_minutes,
    1: ActionTypes.live_stream_1_hour,
    2: ActionTypes.live_stream_2_hours,
    3: ActionTypes.live_stream_3_hours,
    6: ActionTypes.live_stream_6_hours,
};
